import React from "react";
import styled from "styled-components";

import useConfigs from "../hooks/useConfigs";
import useThemes from "../hooks/useThemes";

const NotFound = () => {
  const { fontSizeMultiplier } = useConfigs();
  const { backgroundQuinto, colorPrincipal, colorCuarto } = useThemes();

  return (
    <Cont404
      fontsizemultiplier={fontSizeMultiplier}
      background={backgroundQuinto}
      colortitulo={colorPrincipal}
      color={colorCuarto}
    >
      <h1>404 Not found</h1>
      <p>
        Contenido no encontrado, si escribió la url manualmente por favor revise
      </p>
    </Cont404>
  );
};

export default NotFound;

// ##### Estilos #####
const Cont404 = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 80vh;
  background-color: ${(props) => props.background};

  h1 {
    text-align: center;
    color: ${(props) => props.colortitulo};
    font-size: ${(props) => 65 * props.fontsizemultiplier} !important;
  }

  p {
    text-align: center;
    color: ${(props) => props.color};
    font-size: ${(props) => 16 * props.fontsizemultiplier} !important;
  }
`;
